import SEO from "../common/SEO";
import FooterOne from "../common/footer/FooterOne";
import HeaderFour from "../common/header/HeaderFour";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";

const LAST_UPDATED = "16 de julio de 2026";

const getCustomerNameFromTheme = () => {
  if (typeof window === "undefined") {
    return "la entidad cliente";
  }

  const configSite = window["configSite"] || {};
  return (
    configSite.siteName ||
    configSite.siteTitle ||
    window["APP_HOST"] ||
    "la entidad cliente"
  );
};

const isShortPolicyMode = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  const value = (params.get("v") || "").toLowerCase();
  return value === "short" || value === "1" || value === "true";
};

const PrivacyPolicy = () => {
  const customerName = getCustomerNameFromTheme();
  const shortMode = isShortPolicyMode();

  return (
    <>
      <SEO title="Política de Privacidad" />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderFour />
        <BreadCrumbOne
          title="Política de Privacidad"
          page="Política de Privacidad"
        />
        <div className="section-padding privacy-policy-area">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="privacy-policy-content">
                  <div className="section-title">
                    <h5 className="title">
                      Última actualización: {LAST_UPDATED}
                    </h5>
                  </div>
                  {shortMode ? (
                    <>
                      <h1>Política de Privacidad (Resumen)</h1>
                      <p>
                        <b>Responsable del tratamiento:</b> {customerName}.
                      </p>
                      <p>
                        Recopilamos datos de contacto, datos de uso del servicio
                        y cookies estrictamente necesarias para operar, mejorar
                        y proteger la aplicación.
                      </p>
                      <p>
                        No vendemos información personal. Podemos compartir
                        datos con proveedores que prestan servicios técnicos,
                        siempre bajo obligaciones de confidencialidad y
                        cumplimiento legal.
                      </p>
                      <p>
                        Para fines operativos, comerciales y de cumplimiento con
                        las directrices de Google Play Store y otras tiendas
                        digitales, esta aplicación puede ser publicada,
                        distribuida, mantenida o administrada por Arkadu SAS o
                        por MEREGY LLC, según corresponda.
                      </p>
                      <p>
                        Usted puede solicitar acceso, rectificación, eliminación
                        y demás derechos aplicables a través de los canales de
                        contacto publicados en este sitio.
                      </p>
                      <p style={{ fontSize: "0.9em", color: "#888" }}>
                        Versión resumida para tiendas. Última actualización:{" "}
                        {LAST_UPDATED}
                      </p>
                    </>
                  ) : (
                    <>
                      <h1>Política de Privacidad</h1>
                      <p>
                        <b>Responsable del tratamiento:</b> {customerName}, en
                        su condición de entidad titular del servicio y de los
                        procesos de atención al usuario asociados a esta
                        aplicación.
                      </p>
                      <p>
                        Esta Política de Privacidad describe cómo recopilamos,
                        usamos, almacenamos y protegemos su información personal
                        de acuerdo con las leyes de privacidad aplicables,
                        incluyendo el Reglamento General de Protección de Datos
                        (GDPR) de la Unión Europea, la Ley de Privacidad del
                        Consumidor de California (CCPA), las políticas de Google
                        y otras normativas internacionales.
                      </p>
                      <h4>1. Información que Recopilamos</h4>
                      <ul>
                        <li>
                          <b>Información proporcionada por el usuario:</b>
                          nombre, correo electrónico, dirección, número de
                          teléfono y cualquier otro dato que usted nos
                          proporcione voluntariamente.
                        </li>
                        <li>
                          <b>Datos de uso:</b> información sobre cómo utiliza
                          nuestro sitio web, incluyendo dirección IP, tipo de
                          navegador, páginas visitadas, tiempo de visita y
                          enlaces en los que hace clic.
                        </li>
                        <li>
                          <b>Cookies y tecnologías similares:</b> utilizamos
                          cookies y tecnologías similares para mejorar su
                          experiencia y analizar el tráfico del sitio.
                        </li>
                      </ul>
                      <h4>2. Uso de la Información</h4>
                      <ul>
                        <li>Proveer, operar y mantener nuestros servicios.</li>
                        <li>
                          Mejorar, personalizar y expandir nuestros servicios.
                        </li>
                        <li>
                          Entender y analizar cómo utiliza nuestro sitio web.
                        </li>
                        <li>
                          Comunicarnos con usted, ya sea directamente o a través
                          de uno de nuestros socios, para brindarle
                          actualizaciones y otra información relacionada con el
                          servicio.
                        </li>
                        <li>
                          Cumplir con obligaciones legales y regulatorias.
                        </li>
                      </ul>
                      <h4>3. Compartición de la Información</h4>
                      <ul>
                        <li>No vendemos su información personal a terceros.</li>
                        <li>
                          Podemos compartir información con proveedores de
                          servicios que nos ayudan a operar el sitio web y
                          prestar nuestros servicios (por ejemplo, alojamiento,
                          análisis, marketing), siempre bajo acuerdos de
                          confidencialidad.
                        </li>
                        <li>
                          Podemos divulgar información si es requerido por ley,
                          proceso legal o para proteger nuestros derechos.
                        </li>
                        <li>
                          Si utilizamos servicios de terceros como Google
                          Analytics, estos pueden recopilar información según
                          sus propias políticas de privacidad.
                        </li>
                      </ul>
                      <h4>4. Transferencias Internacionales</h4>
                      <p>
                        Su información puede ser transferida y procesada en
                        países fuera de su jurisdicción. Nos aseguramos de que
                        dichas transferencias cumplan con las leyes aplicables y
                        que existan salvaguardas adecuadas.
                      </p>
                      <h4>5. Derechos del Usuario</h4>
                      <ul>
                        <li>
                          Acceder, rectificar o eliminar su información
                          personal.
                        </li>
                        <li>
                          Oponerse o restringir el procesamiento de sus datos.
                        </li>
                        <li>Solicitar la portabilidad de sus datos.</li>
                        <li>Retirar su consentimiento en cualquier momento.</li>
                        <li>
                          Presentar una reclamación ante una autoridad de
                          control.
                        </li>
                      </ul>
                      <h4>6. Seguridad de la Información</h4>
                      <p>
                        Implementamos medidas técnicas y organizativas
                        razonables para proteger su información personal contra
                        el acceso no autorizado, alteración, divulgación o
                        destrucción.
                      </p>
                      <h4>7. Retención de Datos</h4>
                      <p>
                        Conservamos su información personal solo durante el
                        tiempo necesario para cumplir con los fines descritos en
                        esta política y según lo exijan las leyes aplicables.
                      </p>
                      <h4>8. Privacidad de los Menores</h4>
                      <p>
                        No recopilamos intencionadamente información personal de
                        menores de 16 años. Si usted es padre, madre o tutor y
                        cree que su hijo nos ha proporcionado información
                        personal, contáctenos para eliminarla.
                      </p>
                      <h4>9. Publicación y Distribución de la Aplicación</h4>
                      <p>
                        Para fines operativos, comerciales y de cumplimiento con
                        las directrices de Google Play Store y otras tiendas
                        digitales, esta aplicación puede ser publicada,
                        distribuida, mantenida o administrada por Arkadu SAS o
                        por MEREGY LLC, según corresponda.
                      </p>
                      <p>
                        La entidad que figure como publicador en la tienda
                        correspondiente actúa como operador de la distribución
                        digital de la aplicación. Sin perjuicio de ello, el
                        tratamiento de datos personales de los usuarios del
                        servicio se realiza conforme a esta Política de
                        Privacidad y bajo el marco contractual y normativo
                        aplicable entre las partes.
                      </p>
                      <h4>10. Cambios en la Política de Privacidad</h4>
                      <p>
                        Podemos actualizar esta Política de Privacidad
                        periódicamente. Notificaremos cualquier cambio
                        publicando la nueva política en este sitio web e
                        indicando la fecha de actualización.
                      </p>
                      <h4>11. Contacto</h4>
                      <p>
                        Si tiene preguntas o desea ejercer sus derechos, puede
                        contactarnos a través del correo electrónico
                        proporcionado en nuestro sitio web.
                      </p>
                      <p style={{ fontSize: "0.9em", color: "#888" }}>
                        Última actualización: {LAST_UPDATED}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <CtaLayoutOne />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default PrivacyPolicy;
